<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :title="snDetailsEdit.pkid > 0 ? '编辑' : '新建'"
      width="500px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="snDetailsEdit"
        :rules="ruleValidate"
        class="form"
        label-width="60px">
      <el-form-item label="标签" prop="metaDataNo">
        <div>
          <el-input v-model="snDetailsEdit.metaDataNo" readonly placeholder="请选择标签">
            <el-button slot="append" @click="$refs.selectMetaDataNo.open()"> 选择 </el-button>
          </el-input>
          <mate-data-lable-select ref="selectMetaDataNo" @select="selectMetaDataNo"/>
        </div>
      </el-form-item>
      <el-form-item label="值" prop="metaDataValue">
        <el-input v-model="snDetailsEdit.metaDataValue" placeholder="请输入值"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import MateDataLableSelect from "@/views/information/MaterialSnRule/MateDataLableSelect";
  export default {
    name: "CustomerSnRuleDetailsEdit",
    components: { MateDataLableSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        snDetailsEdit: {
          pkid: 0,
          rowIndex: "",
          metaDataNo: "",
          metaDataId: "",
          metaDataValue: "",
        },
        ruleValidate: {
          metaDataNo: { required: true, message: "请选择标签", trigger: "change" },
          metaDataValue: { required: true, message: "值不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, index) {
        this.dialogVisible = true;
        this.index = index;
        if (index >= 0) {
          this.snDetailsEdit = Object.assign(this.snDetailsEdit, row);
        }
      },

      // 选择标签
      selectMetaDataNo(row) {
        this.snDetailsEdit.metaDataNo = row.metaDataNo;
        this.snDetailsEdit.metaDataId = row.pkid;
      },

      // 提交
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.index < 0) {
              this.dialogVisible = false;
              this.$emit("save-success", this.snDetailsEdit);
            } else {
              this.dialogVisible = false;
              this.$emit("save-success", this.snDetailsEdit, this.index);
            }
          }
        });
      },
    },
  };
</script>
